module.exports = __webpack_public_path__ + "img/thumb_19.110f67c7.jpg";